import { createTheme } from '@mui/material'

export const LightTheme = createTheme({
    palette: {
        primary: {
            main: '#08085C',
            dark: '#04043A',
            light: '#34348A',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#FFB71B',
            dark: '#D99100',
            light: '#FFD36B',
            contrastText: '#08085C',
        },
        background: {
            default: "#f7f6f3",
            paper: "#ffffff"
        }
    }
});
